import { useTranslation } from 'react-i18next'

import { CalendarIcon, Text } from '@mercai/clever'

import { formatDate, textToSnakeCase } from '@/helpers'

import { CardInfo, InfoListListProps } from '@/components'

import type { CardOrderProfileStatusHistoryProps } from './card-order-profile-status-history.type'

export const CardOrderProfileStatusHistory = ({
  taxStatusHistory,
  isLoading,
}: CardOrderProfileStatusHistoryProps) => {
  const { t: tEnums } = useTranslation('enums')
  const { t } = useTranslation('componentCardsOrderCenterShow')

  const mountStatus = () => {
    const statusList: InfoListListProps[] = []

    if (taxStatusHistory) {
      Object.keys(taxStatusHistory)?.forEach((status) => {
        statusList.push({
          label: tEnums(`profile_tax_status_${textToSnakeCase(status)}`),
          value: formatDate(taxStatusHistory[status]),
        })
      })
    }

    return statusList
  }

  const list = mountStatus()

  return (
    <div>
      <CardInfo
        isLoading={isLoading}
        icon={<CalendarIcon />}
        title={t('orderProfileStatusHistoryTitle')}
        items={list}
      >
        {list.length === 0 && (
          <Text>{t('orderProfileStatusHistoryEmptyLabel')}</Text>
        )}
      </CardInfo>
    </div>
  )
}
